import { ref } from 'vue'
import { log } from '@/services/log'

export function useUserActivityWorker() {
  const userActivityWorker = ref(null)

  if (typeof window !== 'undefined') {
    userActivityWorker.value = new Worker(new URL('@/workers/user-activity.js', import.meta.url), { type: 'module' })
  }

  const sendMessage = (obj) => {
    if (userActivityWorker.value) {
      userActivityWorker.value.postMessage(obj)
    } else {
      log('Worker is not initialized.')
    }
  }

  return {
    sendMessage,
  }
}
